export const createUpdateUsersForTenderRequestPayload = (
  selectedUsers: string[],
  preSelectedUsers: string[],
) => {
  const authorizeUserIds = selectedUsers.filter(
    (userId) => !(preSelectedUsers ?? []).includes(userId),
  );
  const deauthorizeUserIds = (preSelectedUsers ?? []).filter(
    (userId) => !selectedUsers.includes(userId),
  );
  return {
    updateUsersForTenderRequest: {
      ...(authorizeUserIds.length > 0 && {
        authorizeUsers: authorizeUserIds,
      }),
      ...(deauthorizeUserIds.length > 0 && {
        deauthorizeUsers: deauthorizeUserIds,
      }),
    },
  };
};
